import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { Button, Grid, Typography, CircularProgress, Divider, TextField, Box } from "@mui/material";
import ImageGalleryHeader from './ImageGalaryHeader';
import ImageGalleryMainArea from './ImageGalaryMainArea';
import ImageGalleryUploadNewImage from './ImageGalaryUploadNewImage';
import { setShowImageGallery,setImageNameUnderSearch,setIntegratedImage } from 'store/slice/ImageGallerySlice';

const ImageGallery = ({label, clickToAction}) => {
    const dispatch = useDispatch();
    const {integratedImage, imageType} = useSelector((state)=>state.imagegalleryslice);
    const { selectedImagePath, selectedImage,linkAssetOption,selectedAssetIdList, holderHeight } = useSelector((state) => state.imagegalleryslice);
    const [linkResult, setLinkResult] = useState(false);
    const [apiInProgress, setApiInProgress] = useState(false);

    useEffect(()=>{
        setLinkResult('')
    },[selectedImage])
    const showUploadImage = () =>{
        dispatch(setShowImageGallery(false));
    }
    const handleContinue = () =>{
        dispatch(setIntegratedImage(selectedImage));
        clickToAction();
    }
    const linkAsset = () =>{
        // let reqPayload = {
        //     "assetpath":selectedImagePath,
        //     "productid":productObj.id,
        //     "title":selectedImage,
        //     "imagetype":imageType
        // }
        // setApiInProgress(true);
        // linkAssetToProductAPI(reqPayload, assetLinkSuccessCallBack, assetLinkFailureCallBack)
    }
    const assetLinkSuccessCallBack = (obj) =>{
       // dispatch(addProductassetObj(obj));
        setApiInProgress(false);
    }
    const assetLinkFailureCallBack = (obj) =>{
        setLinkResult(obj)
        setApiInProgress(false);
    }
    return (
        <>
        
            <Grid container sx={{ width: '100%' }}>
                <ImageGalleryHeader />
                <Box
            sx={{
                width: '100%',           // 3/4th of viewport width
                height: holderHeight,          // 3/4th of viewport height
                maxWidth: '100vw',
                maxHeight: '100vh',
                overflow: 'auto',        // Enable scroll if content exceeds
                margin: 'auto',          // Center the box
                backgroundColor: 'white',
                borderRadius: 2,
                boxShadow: 3,
            }}
        >
                <ImageGalleryMainArea/>
                </Box>
            </Grid>
        
        <Grid container paddingTop={2} direction="row" sx={{alignItems: "center"}}>
            {/* <Grid item lg={6} xs={12} sx={{paddingLeft:2, borderRadius:5, justifyContent: "flex-start",alignItems: "center", backgroundColor:'primary.200'}}>
                <Typography variant="h5">Selected Image </Typography><Typography color="textSecondary" sx={{ fontWeight: 'light',fontSize: 12 }}>'{selectedImage}'</Typography>
            </Grid> */}
            
            <Grid container sx={{
    justifyContent: { xs: "center", sm: "space-between" },
    alignItems: "center",
    padding: 1
}}>
    <Button variant="outlined" onClick={()=>showUploadImage()}>Upload New Image</Button>
    {linkResult === '' ?
        <>
            {apiInProgress ? <CircularProgress/> :
                <>
                    {clickToAction ?
                        <>&nbsp;&nbsp;
                            <Button
                                variant="contained"
                                disabled={selectedAssetIdList.length === 0}
                                onClick={() => clickToAction()}
                                sx={{
                                    mt: { xs: 1, sm: 0 }
                                }}
                            >
                                {label}
                            </Button>
                        </> : null}
                </>
            }
        </>
        : <><Typography color="error" gutterBottom variant="h6">{linkResult}</Typography></>
    }
</Grid>
        
       
    </Grid>
    </>
    )
}
export default ImageGallery;